import Vue from 'vue';
import Main from './main.vue';
import merge from '../../../utils/merge';
import { PopupManager } from 'element-ui/lib/utils/popup';
import { isVNode } from '../../../utils/vdom';
const NotificationConstructor = Vue.extend(Main);

let instance;
let instances = [];
let seed = 1;

const Notification = function (options) {
  if (Vue.prototype.$isServer) return;
  options = merge({}, options);
  const userOnClose = options.onClose;
  const id = 'notification_' + seed++;
  const position = options.position || 'bottom-right';

  options.onClose = function () {
    Notification.close(id, userOnClose);
  };

  instance = new NotificationConstructor({
    data: options
  });

  if (isVNode(options.message)) {
    instance.$slots.default = [options.message];
    options.message = 'REPLACED_BY_VNODE';
  }
  instance.id = id;
  instance.offset = options.offset;
  instance.$mount();
  document.body.appendChild(instance.$el);
  instance.visible = true;
  instance.dom = instance.$el;
  instance.dom.style.zIndex = PopupManager.nextZIndex();

  let verticalOffset = options.offset || 0;
  instances
    .filter(item => item.position === position)
    .forEach(item => {
      verticalOffset += item.$el.offsetHeight + 16;
    });
  verticalOffset += 16;
  instance.verticalOffset = verticalOffset;
  if (instances.length >= 2) {
    instance.visible = false;
  }
  instances.push(instance);
  if (instances.length > 2) {
    console.log('更改前', instances);
    instances[1].showNext = true;
    instances[1].verticalOffset = options.offset + 16;
    instances[0].verticalOffset = instances[1].verticalOffset + instances[0].$el.offsetHeight + 16;
  } else if (instances.length === 2) {
    instances[1].verticalOffset = options.offset + 16;
    instances[0].verticalOffset = instances[1].verticalOffset + instances[0].$el.offsetHeight + 16;
  }

  return instance;
};

['success', 'warning', 'info', 'error'].forEach(type => {
  Notification[type] = options => {
    if (typeof options === 'string' || isVNode(options)) {
      options = {
        message: options
      };
    }
    options.type = type;
    return Notification(options);
  };
});

Notification.close = function (id, userOnClose) {
  let index = -1;
  const len = instances.length;
  const _instance = instances.filter((item, i) => {
    if (item.id === id) {
      index = i;
      return true;
    }
    return false;
  })[0];
  if (!_instance) return;

  if (typeof userOnClose === 'function') {
    userOnClose(_instance);
  }
  instances.splice(index, 1);

  if (len <= 1) return;
  const position = _instance.position;
  const removedHeight = _instance.dom.offsetHeight;
  for (let i = index; i < len - 1; i++) {
    if (instances[i].position === position) {
      instances[i].dom.style[_instance.verticalProperty] =
        parseInt(instances[i].dom.style[_instance.verticalProperty], 10) - removedHeight - 16 + 'px';
    }
  }
};

Notification.closeAll = function () {
  for (let i = instances.length - 1; i >= 0; i--) {
    instances[i].close();
  }
};

Notification.getInstances = function () {
  return instances;
};

export default Notification;



// WEBPACK FOOTER //
// ./~/vue-xpc/src/components/notification/src/main.js